module.exports = __webpack_public_path__ + "static/media/user-alt.e7e6799e.svg";